// extracted by mini-css-extract-plugin
module.exports = {"btn":"SubmitBtn_btn__22Q3A"};